export enum UploadAvatarType {
  User,
  Company,
  SecondaryCompany,
}
